import Bordplassering from "./Bordplassering";

export default Bordplassering;
